// extracted by mini-css-extract-plugin
export var gif = "_ci-0";